import { extendObservable, runInAction } from 'mobx';

import { PURCHASE_TYPES } from '../../../models/PaymentType';
import { PaymentTypeController } from '../../../networking/controllers/PaymentTypeController';

class PaymentStoreClass {
  constructor() {
    extendObservable(this, {
      paymentTypes: null,
      paymentTypeError: false,
    });
  }

  async getPaymentTypes(purchaseType) {
    if (!Object.values(PURCHASE_TYPES).includes(purchaseType)) {
      return;
    }
    runInAction(() => {
      this.paymentTypes = null;
      this.paymentTypeError = false;
    });
    try {
      const paymentTypes = await PaymentTypeController.all(purchaseType);
      runInAction(() => {
        this.paymentTypes = paymentTypes;
      });
    } catch (error) {
      runInAction(() => {
        this.paymentTypeError = true;
      });
    }
  }
}

const PaymentStore = new PaymentStoreClass();

export { PaymentStore };



// WEBPACK FOOTER //
// ./src/pages/payment-methods-and-billing/stores/PaymentStore.js